export const useDefaultData = ({ Helpers }) => {

    const {
        getCurrentDate,
        getCurrentStartMonth
    } = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFilterForm = {
        startDate: getCurrentStartMonth(),
        endDate: getCurrentDate(),
        idcaja: 'ALL',
        movimiento_tipo: 'ALL'
    }

    const defaultFormScreen = {
        iddetalle: '',
        idoperacion: '',
        idmodulo: '',
        idseccion: '',
        idcontrato: '',
        idpago: '',
        idtransaccion: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFilterForm,
        defaultFormScreen
    })
}